import React from 'react';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineOppositeContent,
  TimelineDot,
  TimelineContent,
} from '@mui/lab';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import styles from './index.module.scss';
import classNames from 'classnames';
import Content from './TimelineContent';
import useTimeline from '../hooks/useTimeline';
import { isEmpty, orderBy } from 'lodash';
import { eventType } from '../NewEventModal';

interface IDescription {
  name: string;
  description: string;
}
export interface IEventsList {
  name: string;
  date: string;
  icon?: React.ElementType;
  description?: string | IDescription[];
  status?: number;
  ctaText?: string;
  cta?(): void;
  circle?: {
    color: string;
    value?: number;
  };
  isToShowUpdateIcons?: boolean;
  id?: number | string;
  onDelete?(id: number | string): void;
  tabName?: eventType;
  isToHideEditIcon?: boolean;
}

function EventsList() {
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const events = useTimeline(patientUuid);

  if (isEmpty(events)) {
    return <div>No Timeline events for this patient!</div>;
  }

  return (
    <Timeline position="right" className={classNames(styles.root)}>
      {Object.keys(events).map((eventKey) => (
        <TimelineItem key={eventKey}>
          <TimelineOppositeContent classes={{ root: styles.timelineOppositeContent }}>
            {eventKey}
          </TimelineOppositeContent>
          <TimelineSeparator classes={{ root: 'relative' }}>
            <TimelineDot classes={{ root: styles.timelineDot }} />
            <TimelineConnector classes={{ root: styles.timelineConnector }} />
          </TimelineSeparator>
          <TimelineContent>
            <Content
              events={orderBy<IEventsList>(
                (events[eventKey] || []) as IEventsList[],
                'date',
                'desc',
              )}
            />
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
export default observer(EventsList);
